import { useSmartProp } from '@smartfire/js-block-engine';
import {
    PanelBody,
    PanelRow,
    SelectControl,
    TextControl,
    Button as WPButton,
    ButtonGroup,
    IconButton,
} from '@wordpress/components';
import { MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';
import style from './block.module.scss';

export const Inspector = () => {
    const [videos, setVideos] = useSmartProp('videos');
    const [imageTitle, setImageTitle] = useSmartProp('imageTitle');
    const [imageSubtitle, setImageSubtitle] = useSmartProp('imageSubtitle');
    const [anchorId, setAnchorId] = useSmartProp('anchorId');

    const addVideo = () => {
        var newVideos = structuredClone(videos);
        newVideos.push({ type: 'youtube', url: '', id: 0 });
        setVideos(newVideos);
    };

    const updateVideoType = (i, val) => {
        var newVideos = structuredClone(videos);
        newVideos[i].type = val;
        setVideos(newVideos);
    };

    const updateVideoUrl = (i, val, id = 0) => {
        var newVideos = structuredClone(videos);
        newVideos[i].url = val;
        newVideos[i].id = id;
        setVideos(newVideos);
    };

    const deleteVideo = (i) => {
        var newVideos = structuredClone(videos);
        newVideos.splice(i, 1);
        setVideos(newVideos);
    };

    const moveVideoUp = (i) => {
        if (i > 0) {
            var newVideos = structuredClone(videos);
            newVideos.splice(i - 1, 0, newVideos.splice(i, 1)[0]);
            setVideos(newVideos);
        }
    };

    const moveVideoDown = (i) => {
        if (i < videos.length - 1) {
            var newVideos = structuredClone(videos);
            newVideos.splice(i + 1, 0, newVideos.splice(i, 1)[0]);
            setVideos(newVideos);
        }
    };

    return (
        <>
            <PanelBody title="Paramètres" initialOpen={true}>
                <PanelRow>
                    <TextControl label={'Ancre ID'} value={anchorId} onChange={setAnchorId} />
                </PanelRow>
                <PanelRow>
                    <TextControl label="Titre de l'image" value={imageTitle} onChange={setImageTitle} />
                </PanelRow>
                <PanelRow>
                    <TextControl label="Sous-titre de l'image" value={imageSubtitle} onChange={setImageSubtitle} />
                </PanelRow>
                <PanelRow>
                    <WPButton isPrimary={true} onClick={() => addVideo()}>
                        Ajouter une vidéo
                    </WPButton>
                </PanelRow>
            </PanelBody>
            {videos.map((video, i) => {
                return (
                    <PanelBody title={'Vidéo ' + (i + 1)} initialOpen={true} key={i}>
                        <PanelRow className={style.editFieldNoMargin}>
                            <SelectControl
                                label="Type"
                                value={video.type}
                                onChange={(value) => {
                                    updateVideoType(i, value);
                                }}
                                options={[
                                    { value: 'youtube', label: 'Youtube' },
                                    { value: 'vimeo', label: 'Viméo' },
                                    { value: 'media', label: 'Média mp4' },
                                ]}
                            />
                        </PanelRow>
                        <PanelRow className={style.editFieldNoMargin}>
                            {(video.type === 'youtube' || video.type === 'vimeo') && (
                                <TextControl
                                    label="URL"
                                    value={video.url}
                                    onChange={(value) => {
                                        updateVideoUrl(i, value);
                                    }}
                                />
                            )}
                            {video.type === 'media' && (
                                <MediaUploadCheck>
                                    <MediaUpload
                                        onSelect={(value) => {
                                            updateVideoUrl(i, value.url, value.id);
                                        }}
                                        allowedTypes={['video']}
                                        value={video.id}
                                        render={({ open }) => (
                                            <>
                                                {video.id !== 0 ? (
                                                    <>
                                                        <video controls>
                                                            <source src={video.url} type="video/mp4" />
                                                        </video>
                                                        <ButtonGroup>
                                                            <WPButton isDefault onClick={open}>
                                                                Changer la vidéo
                                                            </WPButton>
                                                            <IconButton
                                                                isDefault
                                                                isDestructive
                                                                icon="trash"
                                                                onClick={() => updateVideoUrl(i, '', 0)}
                                                            />
                                                        </ButtonGroup>
                                                    </>
                                                ) : (
                                                    <WPButton isDefault onClick={open}>
                                                        Selectionner une vidéo
                                                    </WPButton>
                                                )}
                                            </>
                                        )}
                                    />
                                </MediaUploadCheck>
                            )}
                        </PanelRow>
                        <PanelRow className={style.editButtonMargin}>
                            <ButtonGroup>
                                {i > 0 && <IconButton isDefault icon="arrow-up-alt2" onClick={() => moveVideoUp(i)} />}
                                {i < videos.length - 1 && (
                                    <IconButton isDefault icon="arrow-down-alt2" onClick={() => moveVideoDown(i)} />
                                )}
                                <WPButton isDestructive={true} onClick={() => deleteVideo(i)}>
                                    Supprimer
                                </WPButton>
                            </ButtonGroup>
                        </PanelRow>
                    </PanelBody>
                );
            })}
        </>
    );
};

export default Inspector;
